import React, { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import LineReceptionMain from '../lineReception';
import KanniKensaku from '../search/kanniKensaku';
import CustomerTree from '../common/customerTree/customerTree';
import { throttle } from '../../commonFunction';

const useStyles = makeStyles({
  root: {
    height: 'calc(100vh - 57px)',
    overflow: 'hidden',
  },
  main: {
    display: 'flex',
    margin: '0 auto',
    width: '100%',
    overflow: 'hidden',
  },
  sideMenu: {
    width: 240,
    flexShrink: 0,
  },
  contents: {
    flexGrow: 1,
    overflow: 'auto',
  },
});

function LineReceptionListPage() {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const setRowPages = (pageCount) => {
    setRowsPerPage(pageCount);
  };

  const [selectObject, setSelectObject] = useState({
    user: null,
    division: null,
    customer: [],
    uniqueId: null,
  });

  const selectedUserId = selectObject?.user?.userId;
  const responseHeader = useSelector((state) => state.responseHeader);

  const setSelectObjectByKey = (key) => (value) => {
    setSelectObject((prevObj) => ({ ...prevObj, [key]: value }));
  };

  useEffect(() => {
    setSelectObjectByKey('user')({ userId: responseHeader.userId });
  }, [responseHeader.userId]);

  /**
   * 選択されたユーザー更新
   * CustomerTreeのsetSelectCustomerがクリック時に２回走るのでその対応でthrottle使用
   * @param {{customerId: number; customerName: string;}[]} list
   */
  const throttleSetSelectCustomer = useCallback(throttle((list) => {
    setSelectObjectByKey('customer')(list.length === 0 ? [] : list);
  }, 1000), []);

  // 反響ツリーの高さ調整
  const [treeHeight, setTreeHeight] = useState('');
  const [openAccordion, setOpenAccordion] = useState(true);
  const changeAccordion = (d) => {
    setOpenAccordion(d);
  };
  useEffect(() => {
    const accordionHeight = openAccordion ? 464 : 24;
    const height = 144 + accordionHeight;
    setTreeHeight(`calc(100vh - ${height}px)`);
  }, [openAccordion]);
  useEffect(() => {
    setPage(0);
  }, [selectObject]);

  return (
    <div className={classes.root}>
      <Grid className={classes.main}>
        <Grid className={classes.sideMenu}>
          <KanniKensaku changeAccordion={changeAccordion} />
          <CustomerTree
            searchForm={false}
            setSelectUser={setSelectObjectByKey('user')}
            setSelectDivision={setSelectObjectByKey('division')}
            setSelectCustomer={throttleSetSelectCustomer}
            setSelectUniqueId={setSelectObjectByKey('uniqueId')}
            targetFlgList={{
              userFlg: true,
              divisionFlg: true,
              customerFlg: true,
            }}
            defaultUserId={selectObject.user?.userId}
            defaultDivisionId={
              !selectObject.user?.userId ? selectObject.division?.divId : undefined
            }
            defaultUniqueId={selectObject.uniqueId}
            displayCustomer
            treeHeight={treeHeight}
          />
        </Grid>
        <Grid className={classes.contents}>
          <LineReceptionMain
            selectCustomer={selectObject.customer}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowPages={setRowPages}
            selectedUserId={selectedUserId}
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default LineReceptionListPage;
